import React from 'react';
import { Container } from 'react-bootstrap';
import CustomScrollTrigger from 'js/wrapper/CustomScrollTrigger';
import { Parallax } from 'react-scroll-parallax';
import { motion } from 'framer-motion';

import AbstractCmsElement from './AbstractCmsElementNew';


export default class CmsElementGrid extends AbstractCmsElement {
  constructor(props) {
    super(props);

    this.allowStateChange = true;

    this.state = {
      ...this.state,
      shown: false,
    };
  }

  shown = () => {
    if (this.allowStateChange) {
      this.setState({ shown: true });
    }
  };

  render() {
    const { useFlipped, index } = this.props;
    const { shown } = this.state;

    const isFluid = this.getParamValue('isFluid', 'yes') === 'yes';
    const shownClass = shown ? 'elem-shown ' : 'elem-hidden ';

    const parallaxData = this.getParallaxData();

    const innerContent = (
      <div
        id={this.getMainId()}
        className={'ms-grid ' + shownClass + this.getResponsiveClasses()}
        style={{
          ...this.getBackgroundStyle(),
        }}
      >
        {this.getElementStyle()}

        <Container className={this.getPaddingClasses() + this.getCssClasses()} fluid={isFluid}>
          {useFlipped ? (
            <motion.div layoutId={`grid-elem-${index}`}>
              <div>{this.props.children}</div>
            </motion.div>
          ) : (
            this.props.children
          )}
        </Container>

        {this.getAppendHtml()}
      </div>
    );

    return (
      <CustomScrollTrigger className="cms-overflow-fix" onEnter={this.shown} {...this.getCustomId()}>
        {parallaxData ? (
          <Parallax {...parallaxData}>
            {innerContent}
          </Parallax>
        ) : (
          innerContent
        )}
      </CustomScrollTrigger>

    );
  }
}
CmsElementGrid.defaultProps = {
  index: '0',
};
